import styled from 'styled-components';

export const HeaderWrapper = styled.section`
  display: flex;
  gap: 14px;
  width: 100%;
  min-width: 327px;
`;

export const LogoWrapper = styled.div``;

export const AppLogo = styled.img`
  width: 129px;
  height: 129px;
  object-fit: contain;
`;

export const HeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderAppName = styled.h5`
  color: #000000;
  font-size: 18px;
  font-weight: 500;
  line-height: 23.4px;
  margin-bottom: 4px;
  text-align: left;
  position: relative;
  > span {
    margin-left: 10px;
    color: #636366;
    font-size: 8px;
    font-weight: 500;
    line-height: 10px;
    padding: 1px 5px;
    border-radius: 2px;
    border: 0.5px solid #636366;
    position: absolute;
    right: 30px;
    bottom: 5px;
  }
`;

export const HeaderInfoText = styled.p`
  color: #7b7b7b;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  margin-bottom: 4px;
  text-align: left;
`;

export const HeaderAppText = styled(HeaderInfoText)`
  color: #007aff;
`;

export const HeaderDesignedText = styled(HeaderInfoText)`
  margin-bottom: 6px;
  font-size: 10px;
  line-height: 13px;
`;

export const HeaderRatingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const HeaderStars = styled.img`
  width: 50px;
  height: 8px;
`;

export const HeaderAppValue = styled(HeaderDesignedText)`
  margin-bottom: 0;
  color: #bcbcbc;
`;

export const HeaderSmallDot = (
  <svg width="2" height="2" viewBox="0 0 2 2" fill="none">
    <circle cx="1" cy="1" r="1" fill="#8B8B8B" />
  </svg>
);

export const HeaderFreeText = styled(HeaderInfoText)`
  margin: 16px 0;
`;

export const Separator = styled.div`
  min-height: 1px;
  width: 100%;
  min-width: 330px;
  background-color: #d6d6d6;
  margin: 24px 0;
`;

export const MainTitle = styled.h3`
  width: 100%;
  text-align: left;
  margin-bottom: 16px;
  color: #323232;
  font-size: 18px;
  font-weight: 700;
  line-height: 23.4px;
`;

export const RatingWrapper = styled.section`
  display: flex;
  width: 100%;
  align-items: flex-end;
  justify-content: space-between;
`;

export const RatingValue = styled.div`
  color: #323232;
  font-size: 64px;
  font-weight: 700;
  line-height: 64px;
  letter-spacing: -4.8px;
`;

export const StarsLinesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const RatingStarsImg = styled.img`
  width: 53px;
  height: 56px;
  object-fit: contain;
`;

export const RatingLinesImg = styled.img`
  width: 147px;
  height: 50px;
  object-fit: contain;
`;

export const ValuesWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 5px;
  > span {
    color: #7b7b7b;
    font-size: 12px;
    font-weight: 400;
    line-height: 15.6px;
    &:first-child {
      margin-left: 30px;
    }
  }
`;

export const PrivacyText = styled.div`
  width: 100%;
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 15.6px;
  text-align: left;
  > span {
    color: #007aff;
  }
`;

export const DataWrapper = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  margin-top: 24px;
`;

export const DataItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 24px;
  background-color: #f6f6f6;
  border-radius: 8px;
`;

export const DataItemImg = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  margin-bottom: 12px;
`;

export const DataItemTitle = styled.h3`
  color: #323232;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  margin-bottom: 8px;
`;

export const DataItemDescription = styled.p`
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 20px;
`;

export const DataImgWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const DataFeatureWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 110px;
  &:nth-child(odd) {
    margin-right: 20px;
  }
  &:last-child {
    margin-right: 0px;
  }
`;

export const DataFeatureImg = styled.img`
  width: 24px;
  height: 24px;
  object-fit: contain;
`;

export const DataFeatureText = styled.p`
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const PrivacySubText = styled.div`
  margin-top: 16px;
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
`;

export const FamilySharingWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

export const FamilySharingImg = styled.img`
  width: 79px;
  height: 51px;
  object-fit: contain;
`;

export const FamilySharingText = styled.p`
  color: #5e5e5e;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
`;

export const Links = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const Linkbutton = styled.button`
  background: unset;
  border: unset;
  text-decoration: underline;
  font-size: 12px;
  line-height: 24px;
  color: #707070;

  &:last-child {
    margin-left: 20px;
  }
`;

export const StyledDisclaimer = styled.div`
  font-size: 12px;
  color: #5e5e5e;
  text-align: left;
  padding-bottom: 10px;

  span {
    text-decoration: underline;
    cursor: pointer;
  }
`;
